import React from 'react';
import { ContentHeader, ContentBody } from 'areas/shared/components';
import { Grid } from 'fw/forms';
import { Button } from 'fw/components';
import API from 'fw/system/API';
import * as APIModules from 'modules/app/API';
import { Col, Row } from 'react-bootstrap';
import SponsorUserInfo from './SponsorUserInfo';
import * as Formatter from 'fw/components/formatter/Formatter';
import * as FormManager from 'fw/forms/form/FormManager'


const columns = [
    { key: 'firstName', name: 'First Name', width: 150 },
    { key: 'lastName', name: 'Last Name', width: 150 },
    { key: 'title', name: 'Title', width: 150 },
    { key: 'email', name: 'Email' },
	{ key: 'primaryContact', name: 'Primary Contact', formatter: Formatter.Check, width: 120, cellClass: "text-center" },
	{ key: 'adminRights', name: 'Admin Rights', formatter: Formatter.Check, width: 100, cellClass: "text-center" },
    { key: 'registrationComplete', name: 'Reg. Complete', formatter: Formatter.Check, width: 100, cellClass: "text-center" },
    { key: 'active', name: 'Active', formatter: Formatter.Check, width: 60, cellClass: "text-center" }
];

class SponsorUsersTab extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState();
    }

    initialState = (props) => {
        return {
            rows: [],
            userId: null
        };
    }

    componentDidMount() {
		if (!this.props.active)
			return;
			
        this.search();
    }

    resetUser = () => {
        this.setState({ userId: null });
    }

    search = (callback) => {
        let me = this;

        var rq = {
            sponsorId: this.props.selectedId
        };

        new API().post(APIModules.Sponsor.url('/sponsorSetup/getSponsorUsers'), rq,
            {
                success: (r) => {
                    let rows = r.data.items;

                    // Store search results
                    this.setState({ 
                        title: r.data.title,
                        rows: rows
                    }, me.resetUser());
                }
            });
    }

    goToUserDetails = () => {
        setTimeout(() => {
            window.scrollTo({
                behavior: "smooth",
                top: this._userDetail.offsetTop
            });
        }, 200);
    }

    onEditUser = (userId) => {
        FormManager.checkUnsavedChanges(() => {
            this.setState({ userId: userId }, () => { this.goToUserDetails() });
        });
    }

    handleUserUpdate = () => {
        this.search();
    }

    handleUserCancel = () => {
        this.resetUser();
    }

    handleAddUser = () => {
		FormManager.checkUnsavedChanges(() => {
       		this.setState({ userId: 0 }, () => { this.goToUserDetails() });
		})
    }

    render() {
        return (
            <React.Fragment>
                <ContentHeader title={`User Details - ${this.state.title}`} description="These are the users associated with the Member" >
                    <Button id="btnAddNew" bsStyle="success" className="pull-right" style={{ marginRight: 0 }}
                        onClick={this.handleAddUser} disabled={this.state.userId === 0}>Add New User</Button>
                </ContentHeader>
                <ContentBody> 
                    <Row>
                        <Col md={12}>
                            <Grid
                                ref={(c) => { this._grid = c }}
                                columns={columns}
                                items={this.state.rows}
                                height={250}
                                className="table-condensed"
                                rowKey="userId"
                                onChange={this.onEditUser}
                                name="default" />
                        </Col>
                    </Row>
                    <div ref={(c) => { this._userDetail = c }}>
                    </div>
                    {this.state.userId !== null &&
                        <React.Fragment>
                            <Row>
                                <Col md={12}>
                                    { <SponsorUserInfo
                                        sponsorId={this.props.selectedId}
                                        userId={this.state.userId}
                                        onUpdate={this.handleUserUpdate}
                                        onCancel={this.handleUserCancel}
                                    /> }
                                </Col>
                            </Row>
                        </React.Fragment>
                    }
                </ContentBody>
            </React.Fragment>
        )
    }
}

export default SponsorUsersTab;


// WEBPACK FOOTER //
// ./src/areas/admin/sponsorSetup/users/SponsorUsersTab.js